import { useNavigate, useParams } from "react-router-dom";
import { Button } from "./Button";
import { FormEvent, useState } from "react";
import { CandidataType } from "../hooks/useCandidatas";
import api from "../services/api";
import { toast } from 'react-toastify'

import { InputNumber } from 'antd'
import type { InputNumberProps } from 'antd'
import { useVotos } from "../context/VotosContext";
import { TailSpin } from "react-loader-spinner";

type CandidataTypeProps = {
    candidata: CandidataType | undefined
}

export function FooterCandidataVote({ candidata }: CandidataTypeProps) {
    const [isLoading, setIsLoading] = useState(false)
    const history = useNavigate()
    const params = useParams()
    const [numVoto, setNumVoto] = useState<number>(1)
    const { votos } = useVotos()

    async function handleSubmit(event: FormEvent) {
        event.preventDefault()
        setIsLoading(true)
        await api.post('candidatas/votar', new URLSearchParams({
            id_concurso: '' + params.id,
            num_votos: numVoto.toString()
        }))
            .then((response) => {
                setIsLoading(false)
                toast.success(response?.data.msg)
                if (response?.data) {
                    history('/')
                }
            })
            .catch((e) => {
                if (e.response) {
                    // Is this the correct way?
                    toast.error(e.response?.data.error)
                }

            })

    }

    const onChange: InputNumberProps['onChange'] = (value) => {
        setNumVoto(Number(value))
    };

    return (
        <div>
            {isLoading && (
                    <div className="loader-overlay">
                        <div className="loader-container">
                            <TailSpin
                                height="100"
                                width="100"
                                color="#00BFFF"
                                ariaLabel="loading"
                            />
                        </div>
                    </div>
                )
                }
            <footer>
                <div className="user-info">
                    <span><b>{candidata?.nome}</b></span>
                    <span>{candidata?.cidade}</span>
                    <span>Top Fã: <b>{candidata?.topfan}</b></span>
                </div>
                <div className="votos-button">
                    <form onSubmit={handleSubmit}>
                        <div className="div-quantity">
                        <span>Votos:</span>
                        <InputNumber size="large" min={1} max={votos?votos:0} defaultValue={1} onChange={onChange} className="numbers"/>
                        </div>
                        <Button type="submit">Confirmar Voto</Button>
                    </form>
                </div>
            </footer>
        </div>
    )
}